import API from '@/assets/libraries/API_Requests';

export async function createNewOperatorView({ name = undefined, filters = undefined, display_settings = undefined, view_type = 'DEVICE' }) {
	try {
		const body = { name, filters, display_settings, view_type };
		const response = await API.Call('POST', `${API.CSC_API_URL}/show_operator/views`, body);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function getAllOperatorViews(view_type = 'DEVICE') {
	try {
		const response = await API.Call('GET', `${API.CSC_API_URL}/show_operator/views?view_type=${view_type}`);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function archiveCustomView(view_id) {
	try {
		const response = await API.Call('DELETE', `${API.CSC_API_URL}/show_operator/views/${view_id}`);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function editCustomView({ view_id, name = undefined, filters = undefined, display_settings = undefined }) {
	try {
		const body = {
			name,
			filters,
			display_settings,
		};
		const response = await API.Call('PUT', `${API.CSC_API_URL}/show_operator/views/${view_id}`, body);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function saveUsersViewsPreference({ view_id, is_hidden = undefined, sort_order = undefined, display_settings = undefined }) {
	try {
		const body = {
			is_hidden,
			sort_order,
			display_settings: display_settings,
		};
		const response = await API.Call('PUT', `${API.CSC_API_URL}/show_operator/users/preferences/views/${view_id}`, body);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function archiveUsersViewsPreference(view_id) {
	//Reset the preferences
	try {
		const response = await API.Call('DELETE', `${API.CSC_API_URL}/show_operator/users/preferences/views/${view_id}`);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function getUsersViewsPreferences({ view_ids = undefined }) {
	try {
		let query_params = new URLSearchParams();

		if (view_ids != undefined) {
			query_params.set('view_ids', view_ids.join(','));
		}

		const response = await API.Call('GET', `${API.CSC_API_URL}/show_operator/users/preferences/views?${query_params.toString()}`);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}
